import { render, staticRenderFns } from "./BookfaceSlider.vue?vue&type=template&id=0a73a0d6&scoped=true&"
import script from "./BookfaceSlider.vue?vue&type=script&lang=js&"
export * from "./BookfaceSlider.vue?vue&type=script&lang=js&"
import style0 from "./BookfaceSlider.vue?vue&type=style&index=0&id=0a73a0d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a73a0d6",
  null
  
)

export default component.exports